import * as React from "react";
import { cn } from "lib/utils";
import { useState } from "react";

// Utility function to generate unique IDs
const generateId = () => `input-${Math.random().toString(36).substr(2, 9)}`;

const Input = React.forwardRef(
  (
    {
      className,
      type = "text",
      label,
      showWarning = false,
      warningMessage = null,
      warningOnlyAfterBlur = false,
      id,
      inputClassName = "",
      onBlur,
      ...props
    },
    ref
  ) => {
    const inputId = id || generateId();
    const [hasBlurred, setHasBlurred] = useState(false);

    const handleBlur = (e) => {
      setHasBlurred(true);
      onBlur?.(e);
    };

    return (
      <div className={cn(className, "relative")}>
        {label && (
          <label
            htmlFor={inputId}
            className={cn(
              "block mb-2 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-black",
              {
                "w-full": !className,
              }
            )}
            style={{ maxWidth: className ? undefined : "100%" }}
          >
            {label}
          </label>
        )}
        <input
          id={inputId}
          type={type}
          className={cn(
            {
              "ring-1 ring-red focus-visible:ring-red border-red":
                showWarning && (!warningOnlyAfterBlur || hasBlurred),
            },
            "flex h-12 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:font-medium placeholder:text-black-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue focus:border-blue disabled:cursor-not-allowed disabled:opacity-50",
            inputClassName
          )}
          ref={ref}
          onBlur={handleBlur}
          {...props}
        />
        {showWarning &&
          (!warningOnlyAfterBlur || hasBlurred) &&
          warningMessage && (
            <p className="text-sm mt-2 text-secondary flex items-center gap-1">
              {/* <span className="material-symbols-outlined scale-75 mb-[1px]">
              error
            </span> */}
              {warningMessage}
            </p>
          )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
